<section class="section-pd">
    <div class="trinka_container container">
        <div class="row align-items-center">
            <div class="col-md-7 col-lg-7 topBannerWrapper">
                <div class="trinka-title mb-0 top-banner-left ">
                    <span class="mb-4 d-block">
                        <img src="assets/images/case-study/osu/osu-logo.svg" style="width:100px" loading="lazy" decoding="async" alt="Oklahoma State University logo" />
                    </span>
                    <h1 class="trinka-sub-title mb-2 p-2">Case Study</h1>
                    <h2><span>DocuMark</span> as a Pedagogical Partner at Oklahoma State University
                    </h2>
                    <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                    <div class="btn-group justify-content-left mt-40">
                        <a 
                        class="filled-btn"
                            [class.disabled]="downloadingMap['/assets/resources/Pilot-Study-Oklahoma-State-University.pdf']"
                            [style.pointerEvents]="downloadingMap['/assets/resources/Pilot-Study-Oklahoma-State-University.pdf'] ? 'none' : 'auto'"
                            (click)="openResourcePDF(
                                '/assets/resources/Pilot-Study-Oklahoma-State-University.pdf',
                                'DocuMark as a Pedagogical Partner at Oklahoma State University'
                            )"
                        >
                        <span *ngIf="downloadingMap['/assets/resources/Pilot-Study-Oklahoma-State-University.pdf']"
                                class="spinner-border spinner-border-sm me-2"></span>
                                
                        {{ downloadingMap['/assets/resources/Pilot-Study-Oklahoma-State-University.pdf'] ? 'Downloading...' : 'Download Now' }}
                        </a>
                    </div> 
                </div>
                
            </div>
            <div class="col-md-5 col-lg-4 offset-lg-1">
                <div class="text-center pc-img">
                    <span>
                        <svg width="1210" height="500" viewBox="0 0 1210 500" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g opacity="0.3" filter="url(#filter0_f_1593_853)">
                            <ellipse cx="639.862" cy="170.5" rx="217.5" ry="217.5" transform="rotate(90 639.862 170.5)" fill="url(#paint0_linear_1593_853)"/>
                            </g>
                            <defs>
                            <filter id="filter0_f_1593_853" x="-6.10352e-05" y="-469.362" width="1279.72" height="1279.72" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                            <feGaussianBlur stdDeviation="211.181" result="effect1_foregroundBlur_1593_853"/>
                            </filter>
                            <linearGradient id="paint0_linear_1593_853" x1="422.362" y1="170.5" x2="666.946" y2="170.5" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#6366F1"/>
                            <stop offset="0.471154" stop-color="#A855F7"/>
                            <stop offset="1" stop-color="#EC4899"/>
                            </linearGradient>
                            </defs>
                        </svg>
                            
                    </span>
                    <img src="assets/images/case-study/osu/chris-rosser.png" class="img-fluid scale-img" style="width:100%" loading="lazy" decoding="async" alt="Chris rosser" />
                </div>
            </div>
        </div>
    </div>
</section>

<div class="modal" id="CaptureLeadForm">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body">
                <button type="button" class="close" data-dismiss="modal"></button>
                <app-capture-lead 
                [resourceUrl]="selectedLink"
                [resourceTitle]="selectedTitle"
                (formSubmitted)="onFormSubmitted($event)">
                </app-capture-lead>
            </div>
        </div>
    </div>
</div>